import { finish, error } from '../../../modules/competitions/actions/move-list';

import api from '../../../api';

export function request(dispatch, { sport, list, displayFields }) {
    api.patch('/competitions/move', {sport, list, displayFields}).then(
        (competition) => dispatch(finish(competition)),
        ({ errors }) => dispatch(error(errors))
    );
}

